import { TriagePage } from "@/components/dashboard/TriagePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/triage")({
  component: TriagePage,
});
